
import React from "react";
import { Modal } from "../modal";
import { valid_password } from "../../../lib/password";
import {Spinner} from "../../funcs/utils";
import {setPassword} from "../../login/login/actions";

const STATE_EDIT_FIRST = "STATE_EDIT_FIRST";
const STATE_EDIT_SECOND = "STATE_EDIT_SECOND";
const STATE_DONE = "STATE_DONE";
const STATE_SETTING_PASSWORD = "STATE_SETTING_PASSWORD";

class SetPasswordDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      first_password: "",
      first_error: "",
      second_password: "",
      second_error: "",
      state: STATE_EDIT_FIRST,
    };

    this.first_ref = React.createRef();
    this.second_ref = React.createRef();
  }

  onFirstAction = () => {
    const result = valid_password(this.props.config, this.state.first_password);
    if (result.valid) {
      this.setState({
        first_error: "",
        second_password: "",
        state: STATE_EDIT_SECOND,
      })
    } else {
      this.setState({
        first_error: result.error,
      })
    }
  }

  onSecondAction = () => {
    if (this.state.first_password !== this.state.second_password) {
      this.setState({
        second_error: "Passwords do not match.",
      })
    } else {
      this.setState({
        state: STATE_DONE,
      })
    }
  }

  onKeyDown = (prop, ref_prop, on_action) => ev => {
    const ENTER_KEY = 13;
    const TAB_KEY = 9;
    if (ev.keyCode === ENTER_KEY) {
      this[ref_prop].current.blur();
    }
    if (ev.keyCode === ENTER_KEY || ev.keyCode === TAB_KEY) {
      on_action();
    }
  }

  renderInput = (
    label, prop, error_prop, ref_prop, on_action, on_click,
    enable, on_change) => {
    const style = {
      width: "50%",
      display: "inline-block",
      paddingRight: "0.5rem",
    };

    const span_style = {
      float: "right",
      fontWeight: "bold",
    }
    const input_style = {
      width: "100%",
      transform: "translate(0, -5px)",
    }
    const _on_change = prop => (ev) => {
      this.setState({
        [prop]: ev.target.value,
        [error_prop]: "",
      }, () => {
        if (on_change) {
          on_change();
        }
      })
    };

    return (
      <div>
        <div>
          <div style={style}>
            <span style={span_style}>{label}</span>
          </div>
          <div style={style}>
            <input
              type="password"
              disabled={!enable}
              style={input_style}
              ref={this[ref_prop]}
              value={this.state[prop]}
              onKeyDown={this.onKeyDown(prop, ref_prop, on_action)}
              onChange={_on_change(prop)}
              onClick={on_click}
              />
          </div>
        </div>
        <div>
          <div style={style}/>
          <div style={style}>
            { this.state[error_prop] }
          </div>
        </div>
      </div>
    )
  }


  onSetPassword = () => {
    this.setState({
      state: STATE_SETTING_PASSWORD,
    })

    setPassword(this.props.token, this.state.first_password)
      .then(res => {
        this.setState({
          state: STATE_DONE,
        })
        this.props.onDismiss();
      })
  };

  onSecondClick = () => {
    this.onFirstAction();
  };

  onSecondChange = () => {
    if (this.state.first_password === this.state.second_password) {
      this.setState({
        state: STATE_DONE,
      })
    }
  }

  render = () => {

    const buttons = [
      {
        label: "Set Password",
        disable: this.state.state !== STATE_DONE,
        cb: this.onSetPassword,
      },
      {
        label: "Cancel",
        disable: false,
        cb: () => this.props.onDismiss(),
      }
    ];

    const first_input = this.renderInput(
      "Enter your new password:",
      "first_password",
      "first_error",
      "first_ref",
      this.onFirstAction,
      () => {},
      true);

    const second_input = this.renderInput(
      "Re-enter your new password:",
      "second_password",
      "second_error",
      "second_ref",
      this.onSecondAction,
      this.onSecondClick,
      true,
      this.onSecondChange);

    const body = (
      <div>
        <div style={{height: "1rem"}}/>
        { first_input }
        <div style={{height: "1rem"}}/>
        { second_input }
      </div>
    );
    const spinner = (
      <div align={"center"}>
        <Spinner size={"2rem"}/>
      </div>
    )
    const is_loading = this.state.state === STATE_SETTING_PASSWORD;

    return (
      <Modal
        show={true}
        buttonList={buttons}
        onClose={this.props.onDismiss}
        onDismiss={this.props.onDismiss}>
        { !is_loading && body }
        { is_loading && spinner }
      </Modal>
    );
  };
}

export { SetPasswordDialog };
